import React, { useEffect, useState } from 'react';
import { Grid, Box, Button, Typography } from '@mui/material';
import NetworkTable, {
  ColumnType,
} from '../../UserScreen/InventoryPage/InventorySettings/components/InterfacesTable/NetworkTable/NetworkTable';
import { connect, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import './reportsAnalytics.css';
import '../GeneratedReports/generatedReports.css';
import {
  getScheduledReports,
  downloadScheduledReports,
  deleteScheduledReport,
  getGeneretedReportDownload,
} from '../../actions/Users/authenticateUsageReports';
import TuneIcon from '@mui/icons-material/Tune';
import SearchBar from '../../NewComponents/SearchBar/SearchBar';
import {
  DEFAULT_FILTER_FREQUENCIES,
  DEFAULT_REPORT_TYPES,
  DEFAULT_SITE_REPORT_TYPES,
  DEFAULT_SL_REPORT_TYPES,
} from '../../constants/Constants';
import moment from 'moment-timezone';
import {
  handleDownloadURL,
  getChildrenDpList,
  getReportTableHeaders,
  formatRecurringDateUnit,
} from '../../utils/util';
import { toast } from 'react-toastify';
import ConfigListPopup from './ConfigListPopup';
import calendar from '../../asset/image/clarity_date-line.svg';
import AddReportPopup from '../SubscriptionReports/ReportPopup/AddReportPopup';
import {
  CALL_SCHEDULED_REPORT,
  GET_REPORTS_SUBSCRIPTION_TABLE,
} from '../../actions/types';
import ViewList from '../ScheduledReport/ViewList';
import TableFilters, { FilterConfig, FilterValues } from '../TableFilters';
import { CONFIRM_DIALOG_TITLE } from '../../config';
import ConfirmDialog from '../ConfirmDialog';

const Headers = [
  {
    label: 'Report Name',
    key: 'schedular_name',
    sortKey: 'schedular_name',
    sortable: true,
    type: ColumnType.textWithImage,
    formatPlain: true,
    maxWidth: '80px',
  },
  {
    label: 'Organizations',
    key: 'org',
    sortKey: 'organization',
    sortable: true,
    type: ColumnType.hyperlinkText,
    maxWidth: '108px',
    maxChars: 25,
    nameWithNum: true,
  },
  {
    label: 'Sites',
    key: '_sites',
    sortKey: 'sites',
    sortable: true,
    type: ColumnType.hyperlinkText,
    maxWidth: '108px',
    maxChars: 25,
    nameWithNum: true,
  },
  {
    label: 'Service Lines',
    key: '_svcLines',
    sortKey: 'serviceLines',
    sortable: true,
    type: ColumnType.hyperlinkText,
    maxWidth: '108px',
    maxChars: 25,
    nameWithNum: true,
  },
  {
    label: 'Type',
    key: 'type',
    sortKey: 'type',
    sortable: true,
    formatPlain: true,
    type: ColumnType.text,
    maxWidth: '70px',
  },
  {
    label: 'Status',
    key: 'status',
    sortKey: 'status',
    sortable: false,
    type: ColumnType.text,
    maxWidth: '70px',
    renderCell: (value: string) => {
      const lower = value?.toLowerCase();
      return (
        <div className='generated-report-status'>
          <div
            id={
              lower === 'completed'
                ? 'greenDotSymbol'
                : lower === 'processing' || lower === 'queued' || lower === 'in progress'
                ? 'yellowDotSymbol'
                : ''
            }
          />
          <span>{value}</span>
        </div>
      );
    },
  },
  {
    label: 'Created By',
    key: 'requester',
    sortKey: 'requester',
    sortable: false,
    type: ColumnType.text,
    formatPlain: true,
    maxWidth: '80px',
  },
  {
    label: 'Generated',
    key: 'generated_at',
    sortKey: 'generated_at',
    sortable: true,
    type: ColumnType.text,
    maxWidth: '130px',
    renderCell: (value: string) => (
      <span style={{ whiteSpace: 'nowrap' }}>{value}</span>
    ),
  },
  {
    label: 'Timeframe',
    key: '_timeframe',
    sortable: false,
    type: ColumnType.text,
    maxWidth: '120px',
    renderCell: (value: any) => {
      if (!value?.from && !value?.to) return <span>-</span>;
      return (
        <div>
          <div>{value?.from || '-'}</div>
          <div>{value?.to || '-'}</div>
        </div>
      );
    },
  },
  {
    label: 'Schedule',
    key: 'frequency',
    sortKey: 'frequency',
    sortable: true,
    type: ColumnType.text,
    maxWidth: '60px',
  },
  {
    label: 'Actions',
    key: 'actions',
    type: ColumnType.actions,
    actions: ['download', 'delete'],
    maxWidth: '70px',
  },
];

const filterConfig: FilterConfig[] = [
  {
    key: 'reportType',
    label: 'Type',
    type: 'autocomplete',
    _options: [...DEFAULT_REPORT_TYPES],
    placeholder: '',
  },
  {
    key: 'frequency',
    label: 'Frequency',
    type: 'autocomplete',
    _options: [...DEFAULT_FILTER_FREQUENCIES],
    placeholder: '',
  },
];

const ReportsAnalytics = (props) => {
  const {
    history,
    location,
    authReducer,
    getScheduledReports,
    reports,
    total_count,
    newSummaryStartDate,
    newSummaryEndDate,
    downloadScheduledReports,
    deleteScheduledReport,
    call_scheduled_report,
    limited_report_access,
    site_admin_access,
    sl_admin_access,
  } = props;
  const today_date = moment(new Date()).utc();
  const [filterPopup, setFilterPopup] = useState(false);
  const [tableHeaders, setTableHeaders] = useState<any>([
    ...getReportTableHeaders(
      site_admin_access,
      sl_admin_access,
      Headers,
      limited_report_access,
    ),
  ]);
  const [defaultTypes, setDefaultTypes] = useState<any>(
    site_admin_access && !sl_admin_access
      ? [...DEFAULT_SITE_REPORT_TYPES]
      : !site_admin_access && sl_admin_access
        ? [...DEFAULT_SL_REPORT_TYPES]
        : [...DEFAULT_REPORT_TYPES],
  );
  const [filter_config, setFilterConfig] = useState<any>([...filterConfig]);
  const [reportTypes, setReportTypes] = useState<any>([defaultTypes[0]]);

  const [selectedFrequency, setFrequency] = useState<any>([
    DEFAULT_FILTER_FREQUENCIES[0],
  ]);

  const [selected_dps, setSelectedDps] = useState<any>([]);
  const [openConfigList, setConfigListPopup] = useState(false);
  const [addReportPopup, setAddReportPopup] = useState(false);
  const [tableParams, setTableParams] = useState<{
    page: number;
    size: number;
    sortBy: string;
    sortOrder: string;
    search: string;
  }>({
    page: 1,
    size: 15,
    sortBy: 'generated_at',
    sortOrder: 'desc',
    search: '',
  });
  const dispatch = useDispatch();
  const [result, setResult] = useState<any>([]);
  const [list_pop_up, setListPopUp] = useState(false);
  const [list, setList] = useState<any>([]);
  const [list_title, setListTitle] = useState('');
  const [filters, setFilters] = useState<FilterValues>({
    reportType: [...reportTypes],
    frequency: [...selectedFrequency],
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    onConfirm: {},
  });

  useEffect(() => {
    const updatedFilterConfig = filterConfig.map((item) => {
      if (item.key === 'reportType') {
        return {
          ...item,
          _options: [...defaultTypes],
        };
      }
      return item;
    });

    setFilterConfig([...updatedFilterConfig]);
  }, [defaultTypes]);

  useEffect(() => {
    const dpId = authReducer?.selectedOu?.id;
    if (!dpId) return;
    if (_.isEmpty(authReducer.getOrganisationUnitList)) return;
    let dp_ids: string[] = [dpId];
    if (authReducer?.getOrganisationUnitList?.dps?.length) {
      let parent_org = authReducer.getOrganisationUnitList.dps.find(
        (parent_dp) => parent_dp.id === dpId,
      );
      if (!parent_org || parent_org === undefined) {
        let dps = authReducer.getOrganisationUnitList.dps[0].parent_of;
        parent_org = dps.find((dp) => dp.id === dpId);
      }
      if (parent_org && parent_org !== undefined) {
        try {
          let org_list = getChildrenDpList(parent_org);
          if (org_list?.length) dp_ids.push(...org_list);
        } catch (error) {}
      }
    }
    setSelectedDps(dp_ids);
  }, [authReducer.selectedOu, authReducer.getOrganisationUnitList]);

  useEffect(() => {
    if (
      !_.isEmpty(authReducer.selectedOu) &&
      authReducer.selectedOu.hasOwnProperty('id') &&
      authReducer.selectedOu.id &&
      selected_dps?.length
    ) {
      callGetScheduledReport();
    }
  }, [
    selected_dps,
    newSummaryStartDate,
    newSummaryEndDate,
    reportTypes,
    selectedFrequency,
    tableParams,
  ]);

  useEffect(() => {
    let new_result: any[] = [];
    if (reports?.length && !_.isEmpty(authReducer.userTimezone)) {
      let timezone = authReducer.userTimezone.split(' - ')[0];
      reports.map((row, i) => {
        if (row?.generated_at)
          row.generated_at = moment(row.generated_at)
            .tz(timezone)
            .format('MMM D, YYYY HH:mm');
        row._timeframe = {
          from: row?.from_date
            ? moment(row.from_date).tz(timezone).format('MMM D, YYYY HH:mm')
            : '',
          to: row?.to_date
            ? moment(row.to_date).tz(timezone).format('MMM D, YYYY HH:mm')
            : '',
        };
        if (row?.organization?.length) {
          row.org =
            row?.organization?.length > 1
              ? row.organization[0] + `(${row.organization.length - 1})`
              : row.organization[0];
        }
        if (row?.sites?.length) {
          row._sites =
            row?.sites?.length > 1
              ? row.sites[0] + `(${row.sites.length - 1})`
              : row.sites[0];
        }
        if (row?.serviceLines?.length) {
          row._svcLines =
            row?.serviceLines?.length > 1
              ? row.serviceLines[0] + `(${row.serviceLines.length - 1})`
              : row.serviceLines[0];
        }
        new_result.push({
          ...row,
          imageName: 'fileBlueBg',
          frequency:
            row?.frequency !== 'One-Time' && row?.frequency !== 'Daily'
              ? row.frequency +
                ` (${formatRecurringDateUnit(row?.frequency.toLowerCase(), row.schedule_day)})`
              : row.frequency,
        });
      });
    }
    setResult([...new_result]);
  }, [reports]);

  useEffect(() => {
    setFilters({
      reportType: [...reportTypes],
      frequency: [...selectedFrequency],
    });
  }, [reportTypes, selectedFrequency]);

  const callGetScheduledReport = async () => {
    let report_type = [...reportTypes];
    report_type = report_type.filter((type) => type.label !== 'All');
    let _type: string[] = [];
    if (report_type.length) {
      report_type.map((type) => _type.push(type.label));
    } else
      defaultTypes.map(
        (type) => type.label !== 'All' && _type.push(type.label),
      );

    let freqency = [...selectedFrequency];
    freqency = freqency.filter((freq) => freq.label !== 'All');
    let frequency: string[] = [];
    if (freqency.length) {
      freqency.map((type) => frequency.push(type.name));
    } else
      DEFAULT_FILTER_FREQUENCIES.map(
        (type) => type.label !== 'All' && frequency.push(type.name),
      );
    let payload = {
      org_id: selected_dps,
      from_date: moment(newSummaryStartDate).format('YYYY-MM-DD'),
      to_date: moment(newSummaryEndDate).format('YYYY-MM-DD'),
      search: tableParams.search,
      service_line: [],
      k4_id: [],
      sort_by: tableParams.sortBy,
      sort_order: tableParams.sortOrder,
      type: _type,
      frequency: frequency,
      page: tableParams.page,
      size: tableParams.size,
    };
    getScheduledReports(payload);
  };

  const handleChange = (key: string, value: any) => {
    switch (key) {
      case 'reportType':
        handleChangeReportTypes(value);
        break;
      case 'frequency':
        handleChangeFrequency(value);
        break;
      default:
        console.log('key: ', key);
    }
  };

  const handleChangeReportTypes = (newValue) => {
    let _reports = [...defaultTypes];
    _reports = _reports.filter((type) => type.name !== 'All');
    if (
      _reports?.length > 0 &&
      newValue?.length > 0 &&
      _reports.length === newValue.length
    )
      newValue = [defaultTypes[0]];
    setReportTypes([...newValue]);
    setTableParams({ ...tableParams, page: 1 });
  };

  const handleChangeFrequency = (newValue) => {
    setFrequency([...newValue]);
    setTableParams({ ...tableParams, page: 1 });
  };

  const doSearch = (value: string) => {
    setTableParams({ ...tableParams, search: value, page: 1 });
  };

  const handleActionClick = async (
    type: 'download' | 'delete',
    headerKey: string,
    row: any,
    e: any,
  ) => {
    switch (type) {
      case 'delete':
        setConfirmDialog({
          isOpen: true,
          title: CONFIRM_DIALOG_TITLE,
          subTitle: `Do you want to delete the ${getDeleteMsg(row)}?`,
          onConfirm: () => {
            handleDeleteConfirm(row);
          },
        });
        break;
      case 'download':
        handleDownload(row);
        break;
      default:
        break;
    }
  };

  const getDeleteMsg = (row) => {
    let msg = `Report "${row?.schedular_name}" for "${row?.type}" generated at "${row?.generated_at}"`;
    return msg;
  };

  const handleDownload = async (row) => {
    const resp = await downloadScheduledReports({ file_path: row.path });
    if (resp && resp.data) {
      let fileName = `${row.type}-`;
      fileName +=
        row.serviceLines?.length > 1 || row.sites?.length > 1
          ? 'Multiple'
          : row.serviceLines?.length === 1 && row.serviceLines[0]
            ? `${row.serviceLines[0]}`
            : row.sites?.length === 1 && row.sites[0]
              ? `${row.sites[0]}`
              : '';
      fileName += `.xlsx`;
      await handleDownloadURL(resp, fileName);
    } else
      toast.error('Something went wrong, unable to download the file..', {
        position: toast.POSITION.BOTTOM_LEFT,
      });
  };

  const handleDeleteConfirm = async (toDeleteReport) => {
    if (toDeleteReport) {
      let _toDeleteReport = toDeleteReport;
      let resp = await deleteScheduledReport(_toDeleteReport.id);
      if (resp?.success)
        toast.success(
          `Successfully deleted the ${getDeleteMsg(toDeleteReport)}`,
          { position: toast.POSITION.BOTTOM_LEFT },
        );
      setTableParams({ ...tableParams, page: tableParams.page });
    }
  };

  const handleSorting = (sorting: any) => {
    let sort_order = tableParams.sortOrder == 'asc' ? 'desc' : 'asc';
    let sort_obj = tableHeaders.find((head) => head.key === sorting);
    let sort_by: any = sort_obj?.sortKey ?? sorting;

    setTableParams({ ...tableParams, sortOrder: sort_order, sortBy: sort_by });
  };

  const handlePagination = (newpage, limit) => {
    setTableParams({ ...tableParams, page: newpage, size: limit });
  };

  const handlePerPageChange = (limit) => {
    setTableParams({ ...tableParams, size: limit, page: 1 });
  };

  const handleConfigListPopUp = (
    open = true,
    call_list_api = false,
    toast_msg = '',
  ) => {
    setConfigListPopup(open);

    if (call_list_api) {
      toast.success(toast_msg, { position: toast.POSITION.BOTTOM_LEFT });
    }
    if (!open) {
      setTableParams({ ...tableParams, page: tableParams.page });
      dispatch({ type: GET_REPORTS_SUBSCRIPTION_TABLE, payload: {} });
    }
  };

  const handleAddPopupClick = () => {
    setAddReportPopup(true);
  };

  const handleClosePopup = (e, call_list_api = false, toast_msg = null) => {
    setAddReportPopup(false);
    // setReportEdit(null);
    // setCopyReport(false);

    if (call_list_api) {
      toast.success(toast_msg, { position: toast.POSITION.BOTTOM_LEFT });
      setTableParams({ ...tableParams, page: tableParams.page });
      if (!call_scheduled_report) {
        dispatch({ type: CALL_SCHEDULED_REPORT, payload: true });
      }
    }
  };

  const onHyperlinkClick = (key, value, row) => {
    {
      switch (key) {
        case 'org':
          handleViewList(row.organization, 'Organizations', true);
          break;
        case '_sites':
          handleViewList(row.sites, 'Sites', true);
          break;
        case '_svcLines':
          handleViewList(row.serviceLines, 'Service Lines', true);
          break;
        default:
          console.log('key: ', key);
      }
    }
  };

  const handleViewList = (list, key, open = false) => {
    let list_open = false;
    let _list: any = [];
    let view_title = '';
    if (open && list?.length > 1) {
      list_open = true;
      _list = [...list];
      view_title = key;
    }
    setListPopUp(list_open);
    setList([..._list]);
    setListTitle(view_title);
  };

  return (
    <Grid
      container
      className='d-flex'
      spacing={1}
      style={{ marginTop: '10px' }}
    >
      <Grid item xs={12} md={12}>
        <Grid container className='d-flex' justifyContent={'space-between'}>
          <Grid item>
            <Grid
              container
              className='analytics-top-filters-container'
              spacing={1}
              style={{ flexWrap: 'nowrap', justifyContent: 'space-between' }}
            >
              <Grid container item xs={2} md={2} className='l-shape-container'>
                <Grid
                  item
                  className={
                    filterPopup ? 'l-shape upper-subscription-report' : ''
                  }
                >
                  <Box
                    className='activityReports-Filter'
                    style={{ width: '100%', height: '100%' }}
                  >
                    <Button
                      variant='outlined'
                      startIcon={<TuneIcon id='filterIcon' />}
                      onClick={() => setFilterPopup((prev) => !prev)}
                      id='filterButton'
                      style={
                        !filterPopup
                          ? {
                              border: '1px solid rgba(36, 76, 132, 1)',
                              height: '32px',
                              marginTop: '0px',
                              minWidth: '32px',
                            }
                          : { minWidth: '32px' }
                      }
                    ></Button>
                  </Box>

                  {filterPopup && (
                    <TableFilters
                      config={filter_config}
                      values={filters}
                      onChange={handleChange}
                    />
                  )}
                </Grid>
              </Grid>
              <Grid
                item
                className='searchbarMaxWidth'
                style={{ marginTop: '-16px' }}
              >
                <SearchBar handleSerach={doSearch}></SearchBar>
              </Grid>
            </Grid>
          </Grid>
          <Grid item hidden={limited_report_access}>
            <Grid
              container
              spacing={1}
              style={{ flexWrap: 'nowrap', justifyContent: 'space-between' }}
            >
              <Grid item>
                {' '}
                <div
                  className='report-btn'
                  style={{ height: '32px', width: '200px' }}
                  onClick={() => {
                    handleConfigListPopUp(true);
                  }}
                >
                  <Button style={{ padding: '4px 8px' }}>
                    <img
                      src={calendar}
                      alt='setting'
                      style={{ display: 'block', marginRight: '5px' }}
                      width='18'
                      height='18'
                    />
                    <Typography className='btn-text'>
                      Scheduled Reports
                    </Typography>
                  </Button>
                </div>
                {openConfigList && (
                  <ConfigListPopup
                    open={openConfigList}
                    onClose={(e, call_list_api, toast_msg) => {
                      handleConfigListPopUp(false, call_list_api, toast_msg);
                    }}
                    sel_dps={selected_dps}
                  />
                )}
              </Grid>
              <Grid item>
                {' '}
                <div
                  className='download-summary-btn'
                  style={{ height: '32px', width: '120px' }}
                  onClick={handleAddPopupClick}
                >
                  <Button style={{ padding: '4px 8px' }}>+ New Report</Button>
                </div>
                {addReportPopup && (
                  <AddReportPopup
                    open={addReportPopup}
                    onClose={(e, is_api, toast_msg) => {
                      handleClosePopup(e, is_api, toast_msg);
                    }}
                    is_report_edit={{}}
                    is_copy_report={false}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={12}>
        <NetworkTable
          data={result}
          columns={tableHeaders}
          sortBy={tableParams.sortBy}
          sortOrder={tableParams.sortOrder}
          enablePagination={true}
          rowsPerPageOptions={[10, 15, 25]}
          defaultRowsPerPage={15}
          headingHeight={40}
          maxHeight={`calc(100vh - 320px)`}
          totalRowCount={total_count}
          onPageChange={handlePagination}
          onRowsPerPageChange={handlePerPageChange}
          page={tableParams.page}
          rowsPerPage={tableParams.size}
          onSortChange={handleSorting}
          onActionClick={handleActionClick}
          onHyperlinkClick={onHyperlinkClick}
        />
      </Grid>

      <ViewList
        closeSitesPopup={handleViewList}
        sitesPopup={list_pop_up}
        sitesData={list}
        title={list_title}
      />

      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  authReducer: state.authReducer,
  errorReducer: state.errorReducer,
  newSummaryStartDate: state.authReducer.newSummaryStartDate,
  newSummaryEndDate: state.authReducer.newSummaryEndDate,
  reports: state.authReducer.getScheduledReportsTable,
  total_count: state.authReducer.getScheduledReportsTableCount,
  call_scheduled_report: state?.authReducer?.call_scheduled_report,
  limited_report_access: state?.authReducer?.limited_report_access,
  site_admin_access: state?.authReducer?.site_admin_access,
  sl_admin_access: state?.authReducer?.sl_admin_access,
});

export default withRouter(
  connect(mapStateToProps, {
    getScheduledReports,
    downloadScheduledReports,
    deleteScheduledReport,
    getGeneretedReportDownload,
  })(ReportsAnalytics),
);
